import { useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import { useForm, useFormValidation } from "../../../../hooks";

import { DateInputBouncer, IconButton, NumberInputBouncer, ReactSelectSingleInput, ReactSelectSingleKeyInput, TextInputPreview } from "../../.."

import { colors } from "../../../../types/types";

import styles from '../MultiFormAplicacionesInmunoterapiaActiva.module.css';

export const AplicacionForm = ({ element, first, index, ladoFlag = true, lados = [], last, reaccionFlag = true, removeElement, tipo = '', updateElement }) => {

    const { permisos } = useSelector(state => state.auth);

    //Valores para fecha
    let dateAux = element.fecha.split(' ')[0];
    let timeAux = element.fecha.split(' ')[1];
    let yearAux = parseInt(dateAux.split('-')[0]);
    let monthAux = parseInt(dateAux.split('-')[1]);
    let dayAux = parseInt(dateAux.split('-')[2]);
    //Variable para control de fecha
    let fechaAux = yearAux + '-' + ((parseInt(monthAux) < 10) ? '0' : '') +  monthAux + '-' + ((parseInt(dayAux) < 10) ? '0' : '') + dayAux;

    const inputRef = useRef(null);
    const [prevFecha, setPrevFecha] = useState(fechaAux);
    const timeoutRef = useRef(null);        // debounce corto
    const forceTimeoutRef = useRef(null);   // timeout forzado largo
    const [notUpdated, setNotUpdated] = useState(true);

    const inputDosisRef = useRef(null);
    const [prevDosis, setPrevDosis] = useState(parseFloat(element.dosis));
    const timeoutDosisRef = useRef(null);        // debounce corto
    const forceTimeoutDosisRef = useRef(null);   // timeout forzado largo

    const { fecha, dosis, ladoAplicacion, reaccion, realizado, onInputChange } = useForm({ fecha: fechaAux, dosis: element.dosis, ladoAplicacion: element.ladoAplicacion, reaccion: element.reaccion, realizado: element.realizado });

    const { formFields, setFormFieldValidation } = useFormValidation([{field: 'fecha', default: true}, {field: 'dosis', default: true}, {field: 'ladoAplicacion', default: true}, {field: 'reaccion', default: true}, {field: 'realizado', default: true}]);

    let fechaSpace = 2;
    let inputSpace = 2;
    let dosisSpace = 2;
    if(!ladoFlag && !reaccionFlag){
        fechaSpace += 2;
        inputSpace++;
        dosisSpace++;
    }else{
        if(!ladoFlag || !reaccionFlag){
            fechaSpace += 2;
        }
    }

    const handleInputFechaChange = (e) => {
        e.preventDefault();

        const nuevaFecha = e.target.value;

        // Limpiar ambos timeouts previos
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (forceTimeoutRef.current) clearTimeout(forceTimeoutRef.current);

        // Cambio de estado
        setNotUpdated(true);

        //Actualización de input
        onInputChange(e);

        // Timeout corto de 300 ms para validar cambios normales
        timeoutRef.current = setTimeout(() => {
            const nuevaDateObj = new Date(nuevaFecha);
            const prevDateObj = new Date(prevFecha);

            const nuevaDia = nuevaDateObj.getDate();
            const prevDia = prevDateObj.getDate();
            const fechaCompleta = nuevaDateObj instanceof Date && !isNaN(nuevaDateObj);

            if (fechaCompleta && nuevaFecha !== prevFecha && !isNaN(prevDia) && nuevaDia !== prevDia) {
                setNotUpdated(false);
                if (forceTimeoutRef.current) clearTimeout(forceTimeoutRef.current);
                updateElement({ id: element.id, fecha: nuevaFecha + ' ' + timeAux, last }); // Ejecutar solo si el día cambió
                setPrevFecha(nuevaFecha);
            }
        }, 300);

        // Timeout largo de 4 s para forzar ejecución aunque no cambie el día
        forceTimeoutRef.current = setTimeout(() => {
            const fechaValida = new Date(nuevaFecha);
            if (!isNaN(fechaValida) && notUpdated) {
                setNotUpdated(false);
                updateElement({ id: element.id, fecha: nuevaFecha + ' ' + timeAux, last }); // Forzar ejecución por inactividad
                setPrevFecha(nuevaFecha);
            }
        }, 4000);

    }

    const handleInputDosisChange = (e) => {
        e.preventDefault();

        if(e.target.value !== ''){

            const nuevaDosis = parseFloat(e.target.value);
    
            // Limpiar ambos timeouts previos
            if (timeoutDosisRef.current) clearTimeout(timeoutDosisRef.current);
            if (forceTimeoutDosisRef.current) clearTimeout(forceTimeoutDosisRef.current);
    
            //Actualización de input
            onInputChange(e);
    
            // Timeout corto de 500 ms para validar cambios normales
            timeoutDosisRef.current = setTimeout(() => {
    
                if (!isNaN(prevDosis) && nuevaDosis !== prevDosis) {
                    setPrevDosis(nuevaDosis);
                    updateElement({ id: element.id, dosis: (e.target.value !== '') ? e.target.value : 0, ladoAplicacion, reaccion });
                }
            }, 500);

        }else{

            //Actualización de input
            onInputChange(e);

        }
    }

    const handleInputLadoAplicacionChange = (e) => {
        let ladoAplicacionAux = e.target.value;
        e.target.value = ladoAplicacion;
        updateElement({ id: element.id, dosis, ladoAplicacion: ladoAplicacionAux, reaccion });
    }

    const handleInputReaccionChange = (e) => {
        let reaccionAux = e.target.value;
        e.target.value = reaccion;
        updateElement({ id: element.id, dosis, ladoAplicacion, reaccion: reaccionAux });
    }

    const handleInputRealizadoChange = (e) => {
        let realizadoAux = e.target.value;
        e.target.value = realizado;
        updateElement({ id: element.id, realizado: realizadoAux });
    }

    useEffect(() => {
        // fecha, dosis, ladoAplicacion, reaccion, realizado
        if(element.fecha !== fecha){
            let dateAux = element.fecha.split(' ')[0];
            let yearAux = parseInt(dateAux.split('-')[0]);
            let monthAux = parseInt(dateAux.split('-')[1]) - 1;
            let dayAux = parseInt(dateAux.split('-')[2]);
            //Variable para control de fecha
            let fechaAux = yearAux + '-' + ((monthAux < 10) ? '0' : '') +  monthAux + '-' + dayAux;
            onInputChange({ target: { name: 'fecha', value: fechaAux } });
        }
        if(element.dosis !== dosis){
            onInputChange({ target: { name: 'dosis', value: element.dosis } });
        }
        if(element.ladoAplicacion !== ladoAplicacion){
            onInputChange({ target: { name: 'ladoAplicacion', value: element.ladoAplicacion } });
        }
        if(element.reaccion !== reaccion){
            onInputChange({ target: { name: 'reaccion', value: element.reaccion } });
        }
        if(element.realizado !== realizado){
            onInputChange({ target: { name: 'realizado', value: element.realizado } });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [element])

    let dosisLabel = 'Dosis (ml)';
    let dosisStep = 0.01;
    let dosisInt = false;
    if(tipo === 'Sublingual' || tipo === 'Oraltek'){
        dosisLabel = 'Gotas';
        dosisStep = 1;
        dosisInt = true;
    }

    return (
        <>
            <div className="row">
                <div className={`col-md-12 col-lg-1 pe-1`}>
                    <div className="mt-2"></div>
                    <TextInputPreview
                        label="&nbsp;"
                        name="index"
                        showLabel={ (first) ? true : false }
                        value={ String(index) }
                    />
                </div>
                <div className={`col-md-12 col-lg-${ fechaSpace } ps-1 pe-1`}>
                    {(permisos.inmunoterapiaUpdate)
                        ? <DateInputBouncer
                            refference={inputRef}
                            formFieldStatus={ formFields['fecha'].status }
                            label={(first) ? "Fecha" : ""}
                            name="fecha"
                            onChange={ handleInputFechaChange }
                            placeholder="dd/mm/aaaa"
                            required={ true }
                            requiredIndicator={ (first) ? true : false }
                            setFormFieldValidation={ setFormFieldValidation }
                            showLabel={ (first) ? true : false }
                            value={ fechaAux }
                        />
                        : <TextInputPreview
                            label={(first) ? "Fecha" : ""}
                            name="fecha"
                            showLabel={ (first) ? true : false }
                            value={ String(fechaAux) }
                        />
                    }
                </div>
                <div className={`col-md-12 col-lg-${ dosisSpace } ps-1 pe-1`}>
                    {(permisos.inmunoterapiaUpdate)
                        ? <NumberInputBouncer
                            refference={inputDosisRef}
                            formFieldStatus={ formFields['dosis'].status }
                            label={(first) ? dosisLabel : ""}
                            name="dosis"
                            onChange={ handleInputDosisChange }
                            required={ true }
                            requiredIndicator={ (first) ? true : false }
                            setFormFieldValidation={ setFormFieldValidation }
                            showLabel={ (first) ? true : false }
                            step={dosisStep}
                            value={ (dosisInt) ? parseInt(dosis) : dosis }
                        />
                        : <TextInputPreview
                            label={(first) ? dosisLabel : ""}
                            name="dosis"
                            showLabel={ (first) ? true : false }
                            value={ (dosisInt) ? parseInt(dosis) : dosis }
                        />
                    }
                </div>
                {(ladoFlag) &&
                <div className={`col-md-12 col-lg-${ inputSpace } ps-1 pe-1`}>
                    {(permisos.inmunoterapiaUpdate)
                        ? <ReactSelectSingleInput
                            formFieldStatus={ formFields['ladoAplicacion'].status }
                            label={(first) ? "Lado" : ""}
                            name="ladoAplicacion"
                            onChange={ handleInputLadoAplicacionChange }
                            required={true}
                            requiredIndicator={ (first) ? true : false }
                            setFormFieldValidation={ setFormFieldValidation }
                            showLabel={ (first) ? true : false }
                            value={ladoAplicacion}
                            values={lados}
                        />
                        : <TextInputPreview
                            label={(first) ? "Lado" : ""}
                            name="ladoAplicacion"
                            showLabel={ (first) ? true : false }
                            value={ladoAplicacion}
                        />
                    }
                </div>
                }
                {(reaccionFlag) && 
                <div className={`col-md-12 col-lg-${ inputSpace } ps-1 pe-1`}>
                    {(permisos.inmunoterapiaUpdate)
                        ? <ReactSelectSingleInput
                            formFieldStatus={ formFields['reaccion'].status }
                            label={(first) ? "Reacción" : ""}
                            name="reaccion"
                            onChange={ handleInputReaccionChange }
                            required={false}
                            requiredIndicator={ false }
                            setFormFieldValidation={ setFormFieldValidation }
                            showLabel={ (first) ? true : false }
                            value={reaccion}
                            values={ ['\u00A0', 'Leve', 'Grande', 'Generalizada'] }
                        />
                        : <TextInputPreview
                            label={(first) ? "Reacción" : ""}
                            name="reaccion"
                            showLabel={ (first) ? true : false }
                            value={reaccion}
                        />
                    }
                </div>
                }
                <div className={`col-md-12 col-lg-${ inputSpace } ps-1 pe-1`}>
                    {(permisos.inmunoterapiaUpdate)
                        ? <ReactSelectSingleKeyInput
                            formFieldStatus={ formFields['realizado'].status }
                            label={(first) ? "Estatus" : ""}
                            name="realizado"
                            onChange={ handleInputRealizadoChange }
                            required={true}
                            requiredIndicator={ (first) ? true : false }
                            setFormFieldValidation={ setFormFieldValidation }
                            showLabel={ (first) ? true : false }
                            value={String(realizado)}
                            values={[{ value: 'false', label: 'Pendiente' }, { value: 'true', label: 'Aplicada' }]}
                        />
                        : <TextInputPreview
                            label={(first) ? "Estatus" : ""}
                            name="realizado"
                            showLabel={ (first) ? true : false }
                            value={(realizado) ? 'Aplicada' : 'Pendiente'}
                        />
                    }
                </div>
                <div className="col-md-12 col-lg-1">
                    {(permisos.inmunoterapiaUpdate && last) &&
                    <>
                        {(first) && <label>&nbsp;</label>}
                        <div className={styles.closeBtnContainer}>
                            <div>
                                <IconButton
                                    icon="Trash3"
                                    iconColor={colors.DANGER}
                                    marginTop={false}
                                    onClick={() => removeElement(element.id)}
                                    type="button"
                                    size={22}
                                />
                            </div>
                        </div>
                    </>
                    }
                </div>
            </div>
        </>
    )
}

AplicacionForm.propTypes = {
  element: PropTypes.any.isRequired,
  first: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  ladoFlag: PropTypes.bool,
  lados: PropTypes.array,
  last: PropTypes.bool.isRequired,
  reaccionFlag: PropTypes.bool,
  removeElement: PropTypes.func.isRequired,
  tipo: PropTypes.string,
  updateElement: PropTypes.func.isRequired,
}